import { Select } from "antd"
import React from "react"

export default function AntdSelect({ id, showSearch, placeholder, size, style, value, options, onChange, ...rest }) {
   // Filter `option.label` match the user type `input`
   const filterOption = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())

   //  const onChange = (value) => {
   //     console.log(`selected ${value}`)
   //  }
   const onSearch = (value) => {
      console.log("search:", value)
   }
   return (
      <Select
         {...rest}
         id={id}
         optionRender={(option) => (
            <span data-testid={`select-option-${option.data?.value ?? option.value}`}>{option.label}</span>
         )}
         showSearch={showSearch || false}
         placeholder={placeholder}
         size={size || "large"}
         style={{ width: "100%", textAlign: "left", ...style }}
         filterOption={filterOption}
         value={value || null}
         options={
            options || [
               {
                  value: "jack",
                  label: "Jack",
               },
               {
                  value: "lucy",
                  label: "Lucy",
               },
               {
                  value: "tom",
                  label: "Tom",
               },
            ]
         }
         onSearch={onSearch}
         onChange={onChange}
      />
   )
}
